// extracted by mini-css-extract-plugin
module.exports = {"LoadingLogo":"AppLoader_LoadingLogo__2MROi","bubbling":"AppLoader_bubbling__2_lXm"};